<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 97.35 78.09"
  >
    <rect
      fill="#78a200"
      x="-8.77"
      y="21.27"
      width="71.1"
      height="35.55"
      transform="translate(-18.07 54.2) rotate(-74.21)"
    ></rect>
    <rect
      fill="#00363d"
      x="57.63"
      y="38.37"
      width="35.55"
      height="35.55"
      transform="matrix(-0.96, 0.27, -0.27, -0.96, 163.25, 89.66)"
    ></rect>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ZendeskSupportIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
